import { createFields } from "../helpers/createFields.js";
const fields = createFields({
  interestedInProfile: {
    __type: "checkbox",
    label: "field.profile_interest_v2",
    name: "interestedInProfile"
  }
});
export {
  fields as default
};
